import { DataTableFilter } from "../types/dataTableFilter.ts";
import { TableFilter } from "~enums/tableFilter.ts";
import { DataTableFilterDefinition } from "~types/dataTableFilterDefinition.ts";

export const useTableFilters = (dataTableFilters: Array<DataTableFilter>, uiFiltersConfig: DataTableFilterDefinition[]) => {
  const filtersConfig = uiFiltersConfig;

  const allFilters = Object.fromEntries(dataTableFilters.map(filter => ([filter.filterKey, filter])))

  const filteredByConfigFilters = filtersConfig?.map((filter) => ({
    ...allFilters[filter.filterKey],
    tableFilterType: filter.tableFilterType || allFilters[filter.filterKey]?.tableFilterType,
  }))

  const primaryFilters = filteredByConfigFilters?.filter(filter => filter.tableFilterType === TableFilter.Primary) as Array<DataTableFilter>;
  const secondaryFilters = filteredByConfigFilters?.filter(filter => filter.tableFilterType === TableFilter.Secondary) as Array<DataTableFilter>;

  return { primaryFilters, secondaryFilters }

}